import { NOTA_DEBITO_TYPES } from "../constants/nota-debito.types";
import { ActionND, NotaDebito, StateND } from "../interfaces/nota-debito.interface";

const initialState: NotaDebito = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toLocaleDateString('en-CA'),
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: [],
        datosDocumento: [],
        
        condicion: '',
        sucursal: '',
        serie:'',
        loadedSucursal: false,
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',

        datosSucursal: null,
        datosDocumento: null,
    
        condicion: '',
        sucursal: '',
        serie: '',
    },

    productosOriginales: [],
    productos: [],
    formProducto: {
        id: 0,
        original: false,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        unidadMedida: '59'
    },

    errorsProducto: {
        id: 0,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,

    clienteEncontrado: null,
    productoEdit: {
        id: 0,
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false
    },
    productoIndex: null,

    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },

    view: 'Formularios',
    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    totalOriginal: 0,
    formObservaciones: {
        referencia: '',
        observaciones: '',
        mostrarObservacionesPdf: true,
        incluirObservacionesCorreo: true,
    },
}

const notaDebitoReducer = (
    state: NotaDebito = initialState,
    action: ActionND
): StateND => {
    switch (action.type) {
        case NOTA_DEBITO_TYPES.ND_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case NOTA_DEBITO_TYPES.ND_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case NOTA_DEBITO_TYPES.ND_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_VIEW:
            return {...state, view: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_TOTAL_ORIGINAL:
            return {...state, totalOriginal: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_PRODUCTOS_ORIGINAL:
            return {...state, productosOriginales: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case NOTA_DEBITO_TYPES.ND_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case NOTA_DEBITO_TYPES.ND_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case NOTA_DEBITO_TYPES.ND_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case NOTA_DEBITO_TYPES.ND_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case NOTA_DEBITO_TYPES.ND_FORMOBSERVACIONES_HANDLE_CHANGE:
            return {...state, formObservaciones: {...state.formObservaciones, ...action.payload}}
        case NOTA_DEBITO_TYPES.ND_RESTART_ALL:
            return initialState
        default:
            return state;
    }
}

export default notaDebitoReducer;